import MyRemoteVideo from '@components/MyRemoteVideo';
import FeatureController from '@fragments/FeatureController';
import { useAppState } from '@providers/AppStateProvider';
import { externalApiUrl } from '@stores/atoms/url';
import { attendeeInfo } from '@stores/selectors/loginInfo';
import { useAtomValue } from 'jotai';
import {
  Container,
  HelpArea,
  HelpButton,
  HelpIcon,
  IntervieweeArea,
  IntervieweeInfo,
} from './style';

const IntervieweeHeader = () => {
  const apiUrl = useAtomValue(externalApiUrl);
  const { joinInfo } = useAppState();
  const { displayNo, recruitNoticeName } = useAtomValue(attendeeInfo);

  const handleHelp = () => {
    window.open(
      `${apiUrl}/videoGuide`,
      '도움말',
      'toolbar=no,scrollbars=no,resizable=no,top=50,left=100,width=820,height=960',
    );
  };

  return (
    <Container>
      <IntervieweeArea>
        <MyRemoteVideo />
        <IntervieweeInfo
          title={`${recruitNoticeName} ${joinInfo?.Name}(${displayNo})`}
        >
          {`${recruitNoticeName}`} <br />
          {`${joinInfo?.Name}(${displayNo})`}
        </IntervieweeInfo>
      </IntervieweeArea>

      <FeatureController />

      <HelpArea>
        <HelpButton onClick={handleHelp}>
          <HelpIcon />
          도움말
        </HelpButton>
      </HelpArea>
    </Container>
  );
};

export default IntervieweeHeader;
